import { Navigate } from 'react-router-dom';

import PrivateRoutes from 'routes/PrivateRoutes';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import AdminIQueue from 'components/admin/pages/AdminIQueue';
import AllTransactionsTable from 'components/admin/pages/AdminIQueue/Transactions/AllTransactionsTable';
import Assets from 'components/admin/pages/Assets/Assets';
import Videos from 'components/admin/pages/Videos/Videos';

import {
  ADMIN_DATABANK,
  ADMIN_DEV_SETTINGS,
  ADMIN_INTELLIGENCE,
  ADMIN_PATIENTS,
  ADMIN_PRACTICES,
  ADMIN_PRACTITIONERS,
  ADMIN_USERS
} from './index';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const Admin = withLazyFallback(() => import('components/admin'));
const AccessLogs = withLazyFallback(() => import('components/admin/pages/AccessLogs/AccessLogs'));
const AdminDashboard = withLazyFallback(() => import('components/admin/pages/Dashboard/Dashboard'));
const ReportingDashboard = withLazyFallback(
  () => import('components/admin/pages/ReportingCenter/ReportingCenter')
);
const PayerRequests = withLazyFallback(
  () => import('components/admin/pages/Requests/Payers/PayerRequests')
);
const Requests = withLazyFallback(() => import('components/admin/pages/Requests/Requests'));
const Imports = withLazyFallback(() => import('components/admin/pages/Imports/Imports'));
const Vendors = withLazyFallback(() => import('components/admin/pages/Vendors'));
const AdminSettingsContainer = withLazyFallback(
  () => import('components/admin/pages/Settings/AdminSettingsContainer')
);
const Roles = withLazyFallback(() => import('components/Roles/Roles'));

const ADMIN_DASHBOARD = [
  {
    path: '',
    element: <PrivateRoutes type="admin" />,
    children: [
      {
        path: 'admin',
        element: <Admin />,
        handle: { title: 'Admin' },
        children: [
          { path: '', element: <AdminDashboard />, handle: { title: 'Dashboard' } },

          ...ADMIN_PRACTICES,
          ...ADMIN_PRACTITIONERS,
          ...ADMIN_PATIENTS,
          ...ADMIN_USERS,
          ...ADMIN_DATABANK,
          ...ADMIN_INTELLIGENCE,
          ...ADMIN_DEV_SETTINGS,
          {
            path: 'admin-i-queue',
            element: <AdminIQueue />,
            handle: { title: 'Admin I-Queue' },
            children: [
              {
                path: 'all-transactions',
                element: <AllTransactionsTable />,
                handle: { title: 'All Transactions' }
              }
            ]
          },
          {
            path: 'reporting-center',
            element: <ReportingDashboard />,
            handle: { title: 'Reporting Center' }
          },
          { path: 'access-logs', element: <AccessLogs />, handle: { title: 'Access Logs' } },
          {
            path: 'requests',
            element: <Requests />,
            handle: { title: 'Requests' },
            children: [{ path: 'payers', element: <PayerRequests />, handle: { title: 'Payers' } }]
          },
          {
            path: 'import',
            element: <Imports />,
            handle: { title: 'Imports' },
            children: [
              { index: true, element: <Navigate to="vendors" replace /> },
              { path: 'vendors', element: <Vendors />, handle: { title: 'Vendors' } }
            ]
          },
          {
            path: 'assets',
            element: <Assets />,
            children: [
              { index: true, element: <Navigate to="videos" replace /> },
              {
                path: 'videos',
                element: <Videos />
              }
            ]
          },
          { path: 'settings', element: <AdminSettingsContainer />, handle: { title: 'Settings' } },
          { path: 'roles', element: <Roles isAdmin forAdmin />, handle: { title: 'Roles' } },
          { path: '*', element: <NotFound portal="admin" /> }
        ]
      }
    ]
  }
];

export default ADMIN_DASHBOARD;
